import Repo from './Repo.js'

export default class RoleRepository extends Repo {
  constructor () {
    super('roles')
  }

  all (q) {
    return super.all(q)
  }

  get (id) {
    return super.get(id)
  }

  paginate (q) {
      return super.paginate(q)
  }
}
